module.exports = __webpack_public_path__ + "img/4_fineStaff_cf.4685e1bf.png";